module.exports = __webpack_public_path__ + "img/MinistriesBG.a8af3f36.jpg";